<template>
  <v-list-item
      v-if="item.href.includes('http')"
      :href="item.href"
      exact
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon"></v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
  <v-list-item
      v-else
      :to="item.href"
      exact
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon"></v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ item.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'MenuLink',
  props:{
    item: {
      type: Object,
      required: true
    }
  }
}
</script>